import { TriangleAlert } from "lucide-react";
import React from "react";
import { iconsPopup } from "utils";

type CenteredModalProps = {
    title?: string;
    type?: string;
    description?: string;
    onClose: () => void;
    onConfirm: () => void;
};

export const CenteredModal = ({
    title = "Đăng xuất",
    type = 'warn',
    description = "Xác nhận đăng xuất.",
    onClose,
    onConfirm
}: CenteredModalProps) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
            <div className="bg-white rounded-md shadow-lg max-w-md w-full">
                {/* Header */}
                <div className="flex justify-between items-center p-4 border-b border-gray-200">
                    <div className="flex justify-between items-center">
                        {iconsPopup[type]}
                        <h2 className="text-lg font-semibold ml-2">{title}</h2>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        &times;
                    </button>
                </div>

                {/* Body */}
                <div className="p-4 space-y-3 text-medium text-gray-700 max-h-60 overflow-y-auto">
                    <p>{description}</p>
                </div>

                {/* Footer */}
                <div className="flex justify-center gap-2 p-4">
                    <button
                        onClick={onConfirm}
                        className="bg-red-500 text-white px-4 py-1 rounded hover:bg-red-600"
                    >
                        Xác nhận
                    </button>
                </div>
            </div>
        </div>
    );
};
